import { UpdateConfirmFileModalComponent } from '../update-confirm-file-modal/update-confirm-file-modal.component';
import { RemoveFileModalComponent } from '../remove-file-modal/remove-file-modal.component';
import { EditFileModalComponent } from '../edit-file-modal/edit-file-modal.component';
import { UploadingFilesModalComponent } from '../uploading-files-modal/uploading-files-modal.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { BrwoseFilesComponent } from '../brwose-files/brwose-files.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Params, ActivatedRoute, Router , RouterModule } from '@angular/router';
import { forkJoin, of, Observable, Subject } from 'rxjs';
import { catchError, mergeMap, takeUntil } from 'rxjs/operators';
import { ClaimsDataService } from '../../../../../_services/_claims/claims-data.service';
import { AlertService, AcmicService } from '@mapfre-design-library/src/public_api';
import { ComponentCanDeactivate } from '../../../../../_guards/exit-page.guard';
import { UploadDocumentService } from '../../../../../_services/upload-document.service';
import { PolicyDetailsService } from '@services/my-insurance/policy-details.service';
import{ NavigationService } from '@services/navigation.service';
import { ActionType } from '@models/widget/action-type.enum';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, BrwoseFilesComponent, MapfreButtonComponent, UploadingFilesModalComponent, EditFileModalComponent, RemoveFileModalComponent, UpdateConfirmFileModalComponent],
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss'],
})
export class UploadDocumentComponent
  implements OnInit, OnDestroy, ComponentCanDeactivate {
  fileObservablesList = [];
  statusObservablesList = [];
  loading: boolean;
  showUploadModal: boolean;
  showEditFile: boolean;
  showDeleteFile: boolean;
  uploadedFile = '';
  claimid: string;
  fileList;
  docType: string;
  files: any = [];
  invalidFileType: string;
  selectedFileData: any = {};
  claim: any = {};
  existConfirmModal = false;
  destroy$ = new Subject<void>();
  clickedOnContinue = false;
  documentDeleted = false;
  loader = false;
  isAcmic = false;
  fileIndex: number;
  constructor(
    private activeRoute: ActivatedRoute,
    private claimsDataService: ClaimsDataService,
    private router: Router,
    private alertService: AlertService,
    private uploadDocumentService: UploadDocumentService,
    private acmicService: AcmicService,
    private policyDetailsService: PolicyDetailsService,
    private navService: NavigationService
  ) {
    this.showUploadModal = false;
    this.showEditFile = false;
    this.showDeleteFile = false;
    this.fileList = [];
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    if (this.fileList.length) {
      return this.clickedOnContinue;
    }
    return true;
  }
  checkAndSetModal() {
    if (this.fileList.length) {
      this.existConfirmModal = true;
    }
  }
  async uploadDocument() {
    let base64String;
    let fileExtension: string;
    let file;
    this.fileObservablesList = [];
    this.statusObservablesList = [];
    for (let index = 0; index < this.files.length; index++) {
      file = this.files[index];
      try {
          base64String = await this.readFileAsync(file);
          const fileNameParts: string[] = file?.name.split('.');
          fileExtension = fileNameParts[fileNameParts.length - 1];
          this.fileObservablesList.push(this.uploadFileSequence(file, index, base64String, fileExtension));
      } catch (error) {
        console.log(error)
      }
    };

    this.invokeUploadApi();
  }
  readFileAsync(file): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }
  areAllFailed(result) {
    return !result.some(r => r || r === null);
  }
  atleastOneFailed(result) {
    return result.some(r => r === false); 
  }
  atleastOneError(result) {
    return result.some(r => r === 'ERROR'); 
  }
  atleastOneInprogress(result) {
    return result.some(r => r === 'IN-PROCESS'); 
  }
  invokeUploadApi() {
    forkJoin(this.fileObservablesList).subscribe(
      (res: any) => {
        const atleastOneUploadFailed = this.atleastOneFailed(res); 
        if(atleastOneUploadFailed) {
          this.loading = false;
        } else {
          this.getUploadStatus();
        }
      },
      () => {
        this.loading = false;
      }
    );
  }
  getUploadStatus() {
    forkJoin([...this.statusObservablesList]).subscribe(
      (combineStatusResults) => {
        this.loading = false;
        if (combineStatusResults && !this.atleastOneError(combineStatusResults)) {
          this.files = [];
          if(this.atleastOneInprogress(combineStatusResults)) {
            this.alertService.success('Your documents are being uploaded. Please note that larger files may require more time.', true);
          } else {
            this.alertService.success('Documents uploaded.', true);
          }
          
          this.router.navigate(['/claims', this.claimid, 'documents']);
        }
      }, () => {
        this.loading = false;
      }
    )
  }
  uploadFileSequence(file: any, index, base64String, fileExtension) {
   
    let  isLegacy, sourceSystem;
    if (this.claim.policyNumber.policyNumber.length === 10) {
      sourceSystem = 'GW';
      isLegacy = false;
    } else {
      sourceSystem = 'AS400';
      isLegacy = true;
    }

    return this.policyDetailsService.getPreSignedDocumentsForUpload(sourceSystem, this.claimid, 'CLAIM', file?.name, isLegacy, this.fileList[index].docTypeKey, " ",this.claim.policyNumber.policyNumber).pipe(
      mergeMap((response: any) => {
        response.SignedDocumentumData.StreamObj = {
          StreamedDocument: base64String.split(',')[1],
          StreamSize: JSON.stringify(file?.size),
          FileExt: fileExtension
        }
        this.statusObservablesList.push(this.policyDetailsService.getUploadFileStatus(response?.PresignedDocumentResponse?.transactionId,this.claim.policyNumber.policyNumber).pipe(catchError(() => of(false))))
        return this.policyDetailsService.sendPresignedUploadDocument(response?.PresignedDocumentResponse?.signedUrl, response.SignedDocumentumData)
      }
      ), catchError(() => of(false)
      ))
  }
                                  
  deleteUploadedDoc() {
    this.files.splice(this.fileIndex, 1);
    this.fileList.splice(this.fileIndex, 1);
    this.documentDeleted = true;
    this.alertService.success('Document removed.', false);
  }
  saveUploadedFileOnEdit(selectedFileData) {
    this.fileList[this.fileIndex].docTypeKey = this.getMappingKeysByDocType(
      selectedFileData.docType
    );
    this.fileList[this.fileIndex].docType = selectedFileData.docType;
    this.alertService.success('Document updated.', false);
  }
  getMappingKeysByDocType(docType) {
    let key;
    switch (docType) {
      case 'Scene Photos':
        key = 'LOCUSPHOTO';
        break;
      case 'Vehicle Photos':
        key = 'VEHPHOTO';
        break;
      case 'Incident Reports':
        key = 'ACCIDENTRP';
        break;
      case 'Receipts/Invoices':
        key = 'INVOICE-C';
        break;
      case 'Other':
        key = 'GNRLCORR';
        break;
    }
    return key;
  }
  saveUploadedFile(docType) {
    if (docType) {
      this.docType = docType;
      this.selectedFileData.docTypeKey = this.getMappingKeysByDocType(docType);
      this.selectedFileData.docType = docType;
      this.fileList.push(this.selectedFileData);
    }
    this.showUploadModal = false;
  }
  isValidFileType(file) {
    this.invalidFileType = '';
    const allowedFileFormats = ['jpeg', 'jpg', 'pdf', 'gif', 'png'];
    if (file.size > 50000 * 1024) {
      this.invalidFileType = 'too_big';
      this.showUploadModal = true;
      return false;
    }
    const type = file.type.split('/');
    if (!allowedFileFormats.includes(type[1])) {
      this.invalidFileType = 'invalid_format';
      this.showUploadModal = true;
      return false;
    }
    return true;
  }
  onFileUpload(event) {
    this.uploadFile(event);
  }
  uploadFile(event) {
    this.showUploadModal = false;
    if (event && event.target && event.target.files[0]) {
      const file = event.target.files[0];
      if (this.isValidFileType(file)) {
        this.files.push(file);
        const todayDate = new Date();
        this.selectedFileData = {
          date: `${
            todayDate.getMonth() + 1
          }/${todayDate.getDate()}/${todayDate.getFullYear()}`,
          photo: event.target.files[0].name,
          docType: '',
        };
        this.showUploadModal = true;
      }
      this.uploadedFile = file.name;
    }
  }
  closeModal() {
    this.showUploadModal = false;
    this.showEditFile = false;
    this.showDeleteFile = false;
    this.existConfirmModal = false;
  }
  onClickCancel() {
    this.clickedOnContinue = false;
    this.router.navigate(['/claims/' + this.claimid + '/documents']);
  }
  updateFiles(val, fileData, event: Event, i) {
    event.stopPropagation();
    event.preventDefault();
    this.selectedFileData = fileData;
    this.uploadedFile = fileData.photo;
    this.fileIndex = i;
    if (val === 'edit') {
      this.showEditFile = true;
      this.showDeleteFile = false;
    } else {
      this.showDeleteFile = true;
      this.showEditFile = false;
    }
  }
  continue() {
    this.clickedOnContinue = true;
    this.loader = true;
    this.navService.saveCurrentAction(ActionType.AddDocuments);
    this.uploadDocument();
  }
  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.loading = false;
    this.activeRoute.params.subscribe((params: Params) => {
      this.claimid = params['claimid'];
      this.claimsDataService.$claimsLossDetails.subscribe((claimsList) => {
        if (claimsList) {
          this.claim = claimsList.find(
            (claim) => claim.number.number === this.claimid
          );
        }
      });
    });
    this.uploadDocumentService
      .getPageExitModal()
      .pipe(takeUntil(this.destroy$))
      .subscribe((showExitConfirmModal) => {
        this.existConfirmModal = showExitConfirmModal;
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
  }
}
